export default "__VITE_ASSET__DqTvvgzT__"